import type { RichTextComponentProps } from '../../../components/AboutAmway/RichTextComponent/RichTextComponent';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformRichTextComponent = (data: CMSTransformerDataType): RichTextComponentProps => {
  const richTextComponent = Array.isArray(data.rich_text_component)
    ? data.rich_text_component[0]
    : data.rich_text_component;
  return {
    componentType: ComponentType.rich_text_component,
    title: richTextComponent.display_title,
    content: richTextComponent.content,
    sanitize: richTextComponent.sanitize ?? false,
    sanitizationConfig: richTextComponent.sanitizationConfig ?? {},
  };
};

export default transformRichTextComponent;
